import { render, staticRenderFns } from "./LayoutChangelog.vue?vue&type=template&id=59d7249b&scoped=true"
import script from "./LayoutChangelog.vue?vue&type=script&lang=js"
export * from "./LayoutChangelog.vue?vue&type=script&lang=js"
import style0 from "./LayoutChangelog.vue?vue&type=style&index=0&id=59d7249b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d7249b",
  null
  
)

export default component.exports